import { Box, chakra } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

type HeroImageProps = {
  children: ReactNode | string;
  className?: string;
};

/**
 * Hero Image component
 */
export default chakra(function HeroImage({
  children,
  className,
}: HeroImageProps) {
  return (
    <Box className={className} display={{ lg: 'flex', base: 'none' }}>
      {children}
    </Box>
  );
});
